export default {
      id: "search-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }